import { UseMutationOptions, UseQueryOptions } from 'react-query'

interface Error {
  message: string
  name: string
  stack: string
}

export type ErrorOrNull = Error | null

export enum AuthErrorModalErrorTypes {
  HOMEOWNER_ERROR = 'homeownerError',
  BUYER_ERROR = 'buyerError',
  CUSTOMER_ERROR = 'customerError'
}

/**
 * Note: Error handler match `error` by checking if it's included in API error message
 * Please provide as long `error` as possible to avoid false positives
 */
interface ErrorPromptBase {
  error: string // Original GQL Error to match with the error message
  skipSentry?: boolean // If `true`, Sentry will be skipped for this error
}

interface ErrorPromptEnabled extends ErrorPromptBase {
  disableErrorPrompts?: false //  for a specific error
  message: string //              User-friendly message to display
}

interface ErrorPromptDisabled extends ErrorPromptBase {
  disableErrorPrompts: true //    for a specific error
  message?: null | undefined //    If disabled, can be null, or undefined, or just omitted. Will be ignored in any case
}

export type ErrorPrompt = ErrorPromptEnabled | ErrorPromptDisabled

export interface GQLErrorHandlerOptions {
  disableErrorPrompts?: boolean // If `true`, toast will not be shown for all errors
  errorPrompts?: ErrorPrompt[] //  Error prompts to use for specific errors
}

// For use with query hooks
export interface OptionQuery<D> extends UseQueryOptions<D, Error>, GQLErrorHandlerOptions {}

// For use with mutation hooks
export interface MutationOption<D, V> extends UseMutationOptions<D, Error, V>, GQLErrorHandlerOptions {}
